import React from 'react'

const Manual_admin_tiempos_comida = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
      <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Admin - Tiempos de Comida
      </h2>
      <p className="text-lg text-gray-700 mb-6">
        La guía explica cómo gestionar y personalizar los tiempos de comidas, incluyendo su edición, creación y desactivación. Su uso permite optimizar la gestión de las comadas y mejorar la eficiencia operativa.
      </p>
      <iframe
        src="https://scribehow.com/embed/Admin__Tiempos_de_Comida__MtBfKeTiT8-H_QboJsLIAA?as=scrollable"
        className="scribe-iframe-general-34"
        width="100%"
        height="5950"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
      ></iframe>
    </div>
  </div>
  )
}

export default Manual_admin_tiempos_comida